<div class="container-fluid">
  <div class="row">
    <app-chart-widget
      [widgetPanelCharts]="widgetPanelCharts"
      [title]="'Vendor Status'"
    ></app-chart-widget>
  </div>
</div>
